import { Box, Divider, Fade } from '@mui/material';
import { useIntl } from 'react-intl';

import MessageDetails from './messageDetails';
import { WebSocketMessage } from './messages';

import { getConfideFormattedDateTime } from '../../assets/utils/helpers';

interface MessageAreaProps {
  list: WebSocketMessage[];
  userId: number;
  messagesEndRef: React.RefObject<HTMLInputElement>
}

const MessageArea = ({ list, userId, messagesEndRef }: MessageAreaProps) => {
  const intl = useIntl();
  const getMessageSender = (id: number) =>
    id === userId
      ? intl.formatMessage({ defaultMessage: 'You' })
      : intl.formatMessage({ defaultMessage: 'Sender' });

  return (
    <Fade in>
      <Box>
        {list &&
          list.length > 0 &&
          list.map(
            ({ id, fromUser, message, createdAt, files }: WebSocketMessage, index) => {
              return (
                <Box key={id}>
                  <MessageDetails
                    sender={getMessageSender(fromUser)}
                    date={getConfideFormattedDateTime(createdAt)}
                    text={message}
                    files={files}
                  />
                  {(index < list.length - 1 || list.length === 1) && (
                    <Divider light />
                  )}
                </Box>
              );
            },
          )}
        <Box ref={messagesEndRef} />
      </Box>
    </Fade>
  );
};

export default MessageArea;
